module.exports = __webpack_public_path__ + "ced507ddb695aa00e1ce927106cbaaa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/formFactors/multi-imager.png
// module id = 1644
// module chunks = 5